import React from 'react'
import {style} from '../../util/style'
import {CardSwitchType} from '../layout/cards/CardSwitch'
import {Overview} from '../layout/Overview'
import {Block} from './Blocks'

const styles = style('overviewblock')

export type OverviewBlockType = {
	title?: string
	items: Array<CardSwitchType>
}

export const OverviewBlock: React.FC<
	OverviewBlockType & {container?: boolean}
> = ({container, title, items}) => {
	if (!items || items.length === 0) return null

	return (
		<Block container={container} className={styles().mod({title})}>
			<Overview container={false} title={title} items={items} />
		</Block>
	)
}
